import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouterModule, RouterOutlet } from '@angular/router';
import { StaticPagesService } from '../../../shared/services/static-page/static-pages.service';
import { CommonModule } from '@angular/common';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-policies-kvkk-detail',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './policies-kvkk-detail.component.html',
  styleUrl: './policies-kvkk-detail.component.scss',
})
export class PoliciesKvkkDetailComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private staticPagesService: StaticPagesService,
    private metaService: Meta
  ) {}

  policiesKvkkDetail: any

  ngOnInit(): void {
    this.getDetail()

    this.activatedRoute.params.subscribe(params => {
      this.getDetail()
    });
  }

  getDetail(){
    const pageUrl = this.activatedRoute.snapshot.params['pageUrl'];
    this.staticPagesService.getPoliciesKvkkDetail(pageUrl).subscribe((data) => {
      this.policiesKvkkDetail = data;
      this.metaService.updateTag({ name: 'description', content: this.policiesKvkkDetail.metaDescription ?? '', });
      this.metaService.updateTag({ name: 'keywords', content: this.policiesKvkkDetail.metaKeyword ?? '', });
    });
  }
}
